/** Customer-facing destinations shared by the app chrome and @yagni. */
export const PRODUCT_DESTINATIONS = {
    // Waiting on you (Oct 2026, the new shell): one inbox across every Team the
    // reader supervises, at the top of the rail and the signed-in home.
    waiting: { surfaceLabel: "Waiting on you", navLabel: "Waiting on you", path: "/waiting" },
    // All teams: one row per Team, under the Team rows on the rail.
    teams: { surfaceLabel: "All teams", navLabel: "All teams", path: "/teams" },
    // Pull request reviews (Oct 2026): every pull request Proctor watches, as a
    // queue. First under Workspace, with the count of reviews held for a person.
    reviews: {
        surfaceLabel: "Pull request reviews",
        navLabel: "Pull request reviews",
        path: "/reviews",
    },
    // Decisions (2026-09-09): the decision ledger. Workspace-wide and visited
    // less than the Teams, so it sits low and quiet under Workspace.
    decisions: { surfaceLabel: "Decisions", navLabel: "Decisions", path: "/decisions" },
    connections: { surfaceLabel: "Connections", navLabel: "Connections", path: "/services" },
    // Usage: revealed under Workspace once there is usage to show.
    usage: { surfaceLabel: "Usage", navLabel: "Usage", path: "/usage" },
    // Settings: last under Workspace on the rail, and behind the workspace
    // switcher too. Its sections are Workspace, People, Spending, Agent runs
    // and You.
    settings: { surfaceLabel: "Settings", navLabel: "Settings", path: "/settings" },
};
/** Placement used by navigation help and the chrome sections that consume it.
 * The signed-in chrome is the rail (Oct 2026): the workspace switcher on top
 * (Settings and invites behind it), Waiting on you, the Teams with
 * All teams under them, then the Workspace group (Pull request reviews, Decisions, Connections,
 * Usage, Settings) above the account. */
export const PRODUCT_NAV_GROUPS = {
    desktop: {
        top: ["waiting"],
        teams: ["teams"],
        workspace: ["reviews", "decisions", "connections", "usage", "settings"],
        workspaceMenu: ["settings"],
    },
};
export function formatNavigationHelp(key, options = {}) {
    const destination = PRODUCT_DESTINATIONS[key];
    const label = options.markdown ? `**${destination.navLabel}**` : destination.navLabel;
    const groups = PRODUCT_NAV_GROUPS.desktop;
    const has = (group) => group.includes(key);
    if (has(groups.top))
        return `choose ${label} at the top of the sidebar`;
    if (has(groups.teams))
        return `choose ${label} under the Teams in the sidebar`;
    if (has(groups.workspace))
        return `choose ${label} under Workspace at the bottom of the sidebar`;
    return `open the workspace menu at the top of the sidebar, then choose ${label}`;
}
/**
 * Retired customer-facing vocabulary (CONTEXT.md reserved/banned words),
 * matched as capitalized product nouns. The single source of truth — backend
 * validators and catalog tests must import this rather than hand-copying the
 * alternation, so retiring (or un-banning) a term happens in one place.
 *
 * Deliberately CASE-SENSITIVE: validators that consume this discard entire
 * composed outputs (Briefs, activation emails) on a hit, and ordinary business
 * English — "wire transfer", "press release", "the full story", "keep a pulse
 * on churn" — must not trip it. Only the capitalized product-noun usage
 * ("the Wire", "your Desk", "today's Edition") is banned.
 */
export const RETIRED_CUSTOMER_TERM_RE = /\b(?:Desks?|Editions?|Stor(?:y|ies)|Pulse|Newsroom|Wire|Press|Field Work)\b/;
//# sourceMappingURL=productNavigation.js.map